import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header-wrapper" }
const _hoisted_3 = { style: {"width":"60px","margin-left":"auto"} }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-center align-center fill-height pa-10"
}
const _hoisted_5 = {
  key: 1,
  class: "content-wrapper no-scroll-bar",
  ref: "scrollTarget"
}
const _hoisted_6 = {
  key: 0,
  class: "badge d-flex justify-center align-center mr-2"
}
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-center pa-5"
}
const _hoisted_8 = { class: "date-picker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        dark: "",
        "max-height": "56"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.routerBack,
            icon: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, {
            style: {"position":"absolute","left":"50%","transform":"translateX(-50%)","margin":"0","padding":"0","max-width":"70%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.childName), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_btn, {
              icon: "",
              onClick: _ctx.showDatePicker
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { large: "" }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("mdi-calendar-filter", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    (_ctx.fetchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_vue_loading, {
            active: _ctx.fetchLoading,
            loader: "bars",
            color: "#EE6090",
            size: { width: '30px', height: '30px' }
          }, null, 8, ["active"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_v_list, {
            lines: "two",
            density: "compact"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupChats, (g) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: g.chatId,
                  value: g.chatId,
                  link: "",
                  onClick: ($event: any) => (_ctx.toDetail(g.chatId))
                }, {
                  append: _withCtx(() => [
                    (g.hasAttachment)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createTextVNode("mdi-file-image", -1)
                            ]))]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "font-weight-bold subtitle-1" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.displayTitle(g)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_list_item_subtitle, { class: "subtitle-2 text-grey-darken-5" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.dayFormat(g.createdAt)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["value", "onClick"]))
              }), 128)),
              _createVNode(_component_v_divider)
            ]),
            _: 1
          }),
          (_ctx.isFetchMoreAttachment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_v_btn, {
                  onClick: _ctx.fetchMoreAttachment,
                  color: "primary",
                  text: "",
                  loading: _ctx.moreFetchLoading
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" もっと見る ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick", "loading"])
              ]))
            : _createCommentVNode("", true)
        ], 512)),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.showPicker,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showPicker) = $event)),
        "max-width": "400",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-center pt-4" }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("年月を選択", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-caption text-center mb-2" }, "年", -1)),
                          _createVNode(_component_v_list, {
                            "scrollable-y": "",
                            style: {"height":"250px","scroll-behavior":"smooth"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearOptions, (year) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: year,
                                  ref_for: true,
                                  ref: el => { if (_ctx.tempYear === year) _ctx.setYearRef(el) },
                                  active: _ctx.tempYear === year,
                                  color: "primary",
                                  onClick: ($event: any) => (_ctx.selectYear(year)),
                                  class: "text-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(year) + "年", 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["active", "onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-caption text-center mb-2" }, "月", -1)),
                          _createVNode(_component_v_list, {
                            "scrollable-y": "",
                            style: {"height":"250px","scroll-behavior":"smooth"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (month) => {
                                return _createVNode(_component_v_list_item, {
                                  key: month,
                                  ref_for: true,
                                  ref: el => { if (_ctx.tempMonth === month) _ctx.setMonthRef(el) },
                                  active: _ctx.tempMonth === month,
                                  color: "primary",
                                  onClick: ($event: any) => (_ctx.selectMonth(month)),
                                  class: "text-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(month) + "月", 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["active", "onClick"])
                              }), 64))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPicker = false))
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("キャンセル", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    color: "blue",
                    onClick: _ctx.dateReset
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("クリア", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    color: "primary",
                    onClick: _ctx.dateSelected
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode("決定", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}